<ng-container cdkPortalOutlet></ng-container>

<div class="arrow" sgtPopoverArrow></div>
